<div class="p-4">
    <h2 class="text-xl font-bold mb-4">Entity State Table (Module)</h2>

    <div class="alert alert-warning" role="alert">
        <b>Achtung:</b> Die Tabelle greift auf echte Datensätze im Backend zu. Keine Testdaten!
    </div>

    <div class="alert alert-info" role="alert">
        Hier eine <a title="Entity State (Angular NGXS Store)" href="https://wiki.westermanngruppe.de/pages/viewpage.action?pageId=260077879" target="_blank">Anleitung</a>.
    </div>

    <button mat-stroked-button (click)="addModule()">
        <mat-icon>add</mat-icon>
        Neuer Datensatz
    </button>

    <table mat-table [dataSource]="(modules$ | async) || []" [trackBy]="trackById">

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Aktionen</th>

            <td mat-cell *matCellDef="let module">
                <button mat-icon-button aria-label="Edit" (click)="editModule(module)">
                    <mat-icon>edit</mat-icon>
                </button>

                <button mat-icon-button color="warn" aria-label="Delete" (click)="deleteModule(module)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let module"> {{ module.id }} </td>
        </ng-container>

        <ng-container matColumnDef="preTitle">
            <th mat-header-cell *matHeaderCellDef> Pre-Title </th>
            <td mat-cell *matCellDef="let module"> {{ module.preTitle }} </td>
        </ng-container>

        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef> Title </th>
            <td mat-cell *matCellDef="let module"> {{ module.title }} </td>
        </ng-container>

        <ng-container matColumnDef="learningUnits">
            <th mat-header-cell *matHeaderCellDef> learningUnits </th>
            <td mat-cell *matCellDef="let module"> {{ getLearningUnitNames(module.learningUnits) }} </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let module"> {{ module.description }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let module"> {{ module.status }} </td>
        </ng-container>

        <!-- Header & Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <mat-paginator [length]="totalItems || 0" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20]"></mat-paginator>

</div>